<script setup lang="ts">
import { useStation } from "@/api/station-query";
import StationSelection from "./StationSelection.vue";

const emit = defineEmits(["close"]);
const props = defineProps({
	id: { type: String, required: true },
});
const id = computed(() => props.id);
const { data: station, isLoading } = useStation(id);

function close() {
	emit("close");
}
</script>

<template>
	<StationSelection
		v-if="station"
		class="border-border border"
		:station="station"
		:isLoading="isLoading"
		@close="close"
	/>
</template>
